/**
 * Photography — a small, hand-picked set of placeholder property images.
 *
 * These are Unsplash CDN URLs. Every one was fetched and visually reviewed
 * before being added here, so no template ships with a broken or off-brief
 * image; the descriptions below are what the photograph actually shows.
 *
 * They are PLACEHOLDERS: in the editor each is an ordinary image element, so a
 * user selects it and swaps in their own listing photo. The app's CSP allows
 * `img-src https:`, so they render in the editor, the thumbnail, and export.
 */

const unsplash = (id, w = 1800) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const PHOTOS = {
  /** Timber chalet at dusk, windows lit warm against a deep blue sky. */
  twilightChalet: unsplash('photo-1568605114967-8130f3a36994'),

  /** White flat-roof villa, pool and palm, hard midday sun. */
  poolsideVilla: unsplash('photo-1512917774080-9991f1c4c750'),

  /** Modern white villa with infinity pool, strong rectilinear geometry. */
  modernWhiteVilla: unsplash('photo-1600596542815-ffad4c1539a9'),

  /** Dark-timber contemporary home at dusk over a clipped lawn. */
  timberDusk: unsplash('photo-1600585154340-be6161a56a0c'),

  /** Contemporary stone-and-render villa with lap pool, warm late light. */
  terracottaVilla: unsplash('photo-1580587771525-78b9dba3b914'),

  /** Bright open-plan living room, grey sectional, timber feature wall. */
  openPlanLiving: unsplash('photo-1600607687939-ce8a6c25118c'),

  /** Warm neutral staged living room, cream sofa, gallery wall. */
  warmNeutralInterior: unsplash('photo-1616486338812-3dadae4b4ace'),

  /** Bright white kitchen, open shelving, island and range. */
  whiteKitchen: unsplash('photo-1556909212-d5b604d0c90d'),

  /** Primary bedroom — charcoal accent wall, cream tufted bed, brass fixture. */
  brassBedroom: unsplash('photo-1616594039964-ae9021a400a0'),

  /** Timber-and-black contemporary exterior, hard daylight. */
  timberBlackExterior: unsplash('photo-1600566753190-17f0baa2a6c3'),

  /** Agent headshot — dark suit, white shirt, neutral daylight background. */
  agentHeadshot: unsplash('photo-1560250097-0b93528c311a', 900),
};
